module.exports = __webpack_public_path__ + "static/img/about-step1.4bf790ce.png";